module.exports = __webpack_public_path__ + "static/canine-craze-teaser-fda6ac3fb51d7cd83d18566640be8a44.jpg";